import {FETCHED_NRG, FETCHED_SPENDABLE_OUTPOINTS} from '../../types';
import { createWallet } from '../../helpers/bc'

export function getNRGBalanceDispatch(){
  return function(dispatch,getState){
    getNRGBalance(dispatch,getState())
  }
}

export async function getSpendableOutpoints(dispatch,state){
  const wallet = createWallet(state.settings.settings)
  if(state.passport.wallet && state.passport.wallet.emb){
    let payload = await wallet.getSpendableOutpoints(state.passport.wallet.emb.address.toLowerCase())
    dispatch({
      type:FETCHED_SPENDABLE_OUTPOINTS,
      payload
    })
  }
}

export async function getNRGBalance(dispatch,state){
  try {
    const wallet = createWallet(state.settings.settings)
    let balance = await wallet.getBalance(state.passport.wallet.emb.address.toLowerCase())
    dispatch({
      type: FETCHED_NRG,
      payload: {nrg:parseFloat(balance.confirmed),unlockable:parseFloat(balance.unlockable),nrg_collateralized:parseFloat(balance.collateralized)}
    });
  }
  catch(err){
    console.log({err})
  }
}
